import { ITender } from 'types/tender'
import { Divider, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { TenderGeneralInfo } from '../tender-general-info'
import { StatusBoxes } from './status-box'
import { useTendersControlPanelQuery } from 'services/tender'
import { Loading } from 'components/Loading'
import { Error } from 'components/Error'
import { QuotationPaymentFiles } from './quotation-payment-files'
import { PaymentSummaryTable } from './payment-summary-table'
import { DocsSubmissionSummaryTable } from './docs-submission-summary-table'
import { PriceProposalSummaryTable } from './price-proposal-summary-table'
import { CommissionEvaluationSummaryTable } from './commission-evaluation-summary-table'
import { CommitteeEvaluationSummaryTable } from './committee-evaluation-summary-table'

type Props = {
  tender: ITender
}

export const ControlPanel = ({ tender }: Props) => {
  const { t } = useTranslation()

  const {
    data: controlPanelSummary,
    isLoading,
    isError,
  } = useTendersControlPanelQuery({ id: tender.id }, { skip: !tender.id })

  if (isLoading) {
    return <Loading fullPage={false} />
  }
  if (isError) {
    return <Error fullPage={false} />
  }
  if (controlPanelSummary === undefined) {
    return <></>
  }

  return (
    <Stack spacing={2}>
      {/* <StatusBoxes /> */}
      <Divider flexItem />
      <TenderGeneralInfo tender={tender} />
      <Divider flexItem />
      <QuotationPaymentFiles controlPanelSummary={controlPanelSummary} />
      {controlPanelSummary.tenderPaymentSummaryList.length > 0 && (
        <PaymentSummaryTable controlPanelSummary={controlPanelSummary} />
      )}
      {controlPanelSummary.submissionSummary.documentSubmissions.length > 0 && (
        <DocsSubmissionSummaryTable controlPanelSummary={controlPanelSummary} />
      )}
      {controlPanelSummary.submissionSummary.procurementSubmissions.length > 0 && (
        <PriceProposalSummaryTable controlPanelSummary={controlPanelSummary} />
      )}
      {controlPanelSummary.commissionEvaluationSummaryList.length > 0 && (
        <CommissionEvaluationSummaryTable
          controlPanelSummary={controlPanelSummary}
        />
      )}
      {controlPanelSummary.committeeEvaluationSummaryList.length > 0 && (
        <CommitteeEvaluationSummaryTable
          controlPanelSummary={controlPanelSummary}
        />
      )}
    </Stack>
  )
}
